import * as React from 'react';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { AdminMedicineModel } from "../../models/medicine";
import { DropdownModel } from "../../models/dropdownModel";
import RouteOfAdministrationService from '../../services/routeOfAdministrationService';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ImageModel } from "../../models/imageModel";
import * as Constants from '../../common/constants';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import * as HelperFunctions from '../../common/functions/helperFunctions';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  addImageClick: any,
  removeImageClick: any,
  toggleImageClick: any,
  handleContentChange: any,
  getContentValue: any
}

interface IState {
  routeOfAdminDropdown: Array<DropdownModel>,
  validationMessage: string
}

class MedicineTabProfessional extends React.Component<IProps, IState> {

  routeOfAdministrationService = new RouteOfAdministrationService();
  growl: any;
  currentImage: ImageModel;
  refImageFile: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      routeOfAdminDropdown: Array<DropdownModel>(0),
      validationMessage: ''
    };
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    this.routeOfAdministrationService.getDropdownList().then(
      (data: Array<DropdownModel>) => {
        const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
        this.setState({
          routeOfAdminDropdown: firstItem.concat(data)
        });
      })
      .catch(error => {
        this.setState({
          //error
        });
      });
  }

  handleOnChange(event) {
    let file: File = event.target.files[0];
    let message = '';
    let fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

    this.currentImage = new ImageModel();

    if (!fileExtension.match(/(png|jpg|jpeg)$/i)) {
      message += 'Allowed file types are (png, jpg, jpeg).<br />';
    }

    if (file.size > Constants.MaxFileUploadSize) {
      message += 'File size is greater than ' + HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3) + '.<br />';
    }

    this.setState({
      validationMessage: message
    });

    if (!message) {
      this.currentImage.imageName = file.name;
      this.currentImage.imageType = fileExtension

      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.currentImage.imageContent = reader.result;
        this.props.addImageClick(this.currentImage);
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  public render() {

    const { specification } = this.props.medicine;
    const { routeOfAdminDropdown } = this.state;

    return (
      <div className="p-grid p-fluid p-md-12">

        {this.state.validationMessage ?
          <div className="p-col-12 p-md-12">
            <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage>
          </div>
          : null}

        <div className="p-col-12 p-md-6">
          <label>Description:</label>
          <Editor
            style={{ width: '100%', height: '120px' }}
            onTextChange={(e) => { this.props.handleContentChange('description', e.htmlValue) }}
            value={this.props.getContentValue('description')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <div className="p-col-12">
            <label>Images:</label>
          </div>
          <div className="p-grid p-md-12" style={{ marginLeft: "2px" }}>
            <input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refImageFile = el} />
            <Button
              type="button"
              label="Add New"
              className="p-button-success"
              tooltip="Add new Image"
              tooltipOptions={{ position: 'top' }}
              onClick={(e) => this.refImageFile.click()}
              style={{ width: 'auto' }}
            />
            <span style={{ padding: '8px 0 0 10px', fontSize: ".9em", fontStyle: 'italic' }}>
              Allowed file types: '.png', '.jpg', '.jpeg' and size up to {HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3)}.
            </span>
          </div>
          <div className="p-col-12 p-md-12">
            <DataTable
              value={specification.images}
            >
              <Column field="imageName" header="Name" body={(rowData, column) =>
                rowData.imageId ? <a href={`${Constants.apiUrl}/image/openFile/${rowData.imageId}/${rowData.imageName}`} target='_blank'>{rowData.imageName}</a>
                  : rowData.imageName
              } />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    {/* <Button
                      type="button"
                      icon="pi pi-search"
                      className="p-button-success"
                      style={{ marginRight: '.5em' }}
                      tooltip="View"
                      tooltipOptions={{ position: 'top' }}
                      onClick={(e) => this.props.toggleImageClick(e, `${AppSettings.apiUrl}/image/openFile/${rowData.imageId}/${rowData.imageName}`)}
                    /> */}
                    <Button
                      type="button"
                      icon="pi pi-times-circle"
                      className="p-button-warning"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.props.removeImageClick(rowData)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>
        <div className="p-col-12 p-md-3" style={{ padding: '7px' }}>
          <label>Pharmaceutical Form:</label>
          <InputText
            name="pharmaceuticalForm"
            onChange={(e) => this.props.handleContentChange('pharmaceuticalForm', e.target['value'])}
            value={this.props.getContentValue('pharmaceuticalForm')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Imprint:</label>
          <InputText
            name="imprint"
            onChange={(e) => this.props.handleChange('imprint', e.target['value'])}
            value={specification && specification.imprint ? specification.imprint : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Strength:</label>
          <InputText
            name="strength"
            onChange={(e) => this.props.handleChange('strength', e.target['value'])}
            value={specification && specification.strength ? specification.strength : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Color:</label>
          <InputText
            name="color"
            onChange={(e) => this.props.handleContentChange('color', e.target['value'])}
            value={this.props.getContentValue('color')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Size:</label>
          <InputText
            name="size"
            onChange={(e) => this.props.handleChange('size', e.target['value'])}
            value={specification && specification.size ? specification.size : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Shape:</label>
          <InputText
            name="shape"
            onChange={(e) => this.props.handleContentChange('shape', e.target['value'])}
            value={this.props.getContentValue('shape')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Packaging:</label>
          <InputText
            name="packaging"
            onChange={(e) => this.props.handleContentChange('packaging', e.target['value'])}
            value={this.props.getContentValue('packaging')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Package size:</label>
          <InputText
            name="packageSize"
            onChange={(e) => this.props.handleContentChange('packageSize', e.target['value'])}
            value={this.props.getContentValue('packageSize')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>DDD (Defined Daily Dose):</label>
          <InputText
            name="ddd"
            onChange={(e) => this.props.handleContentChange('ddd', e.target['value'])}
            value={this.props.getContentValue('ddd')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Score:</label>
          <InputText
            name="score"
            onChange={(e) => this.props.handleContentChange('score', e.target['value'])}
            value={this.props.getContentValue('score')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Item Code:</label>
          <InputText
            name="itemCode"
            onChange={(e) => this.props.handleChange('itemCode', e.target['value'])}
            value={specification && specification.itemCode ? specification.itemCode : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Flavour:</label>
          <InputText
            name="flavour"
            onChange={(e) => this.props.handleContentChange('flavour', e.target['value'])}
            value={this.props.getContentValue('flavour')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Contains:</label>
          <InputText
            name="contains"
            onChange={(e) => this.props.handleContentChange('containsDesc', e.target['value'])}
            value={this.props.getContentValue('containsDesc')}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>First Authorization Date:</label>
          <Calendar
            dateFormat="dd.mm.yy г." showButtonBar={true} monthNavigator={true} yearNavigator={true} yearRange="1950:2050"
            showIcon={true} readOnlyInput={true}
            value={specification.firstAuthorizationDate ? new Date(specification.firstAuthorizationDate) : new Date()}
            onChange={(e) => this.props.handleChange('firstAuthorizationDate', e.value)}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Last Authorization Date:</label>
          <Calendar
            dateFormat="dd.mm.yy г." showButtonBar={true} monthNavigator={true} yearNavigator={true} yearRange="1950:2050"
            showIcon={true} readOnlyInput={true}
            value={specification.lastAuthorizationDate ? new Date(specification.lastAuthorizationDate) : new Date()}
            onChange={(e) => this.props.handleChange('lastAuthorizationDate', e.value)}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Route of Administration:</label>
          <Dropdown
            value={specification && specification.roaTypeId ? specification.roaTypeId : ""}
            options={routeOfAdminDropdown}
            onChange={(e) => this.props.handleChange('roaTypeId', e.value)}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    )
  }
}

export default MedicineTabProfessional;